var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WatchCardCtrl',{attrs:{"life-cycle":_vm.lifeCycle},on:{"on-setting":_vm.onSetting,"on-copy-link":_vm.onCopyLink,"on-edit":_vm.onEdit,"on-delete":_vm.onDelete,"on-report":_vm.onReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }